import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";

function Works3() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center px-24">
          <div className="flex text-4xl font-bold">
            <p className="text-main">메이커 운동</p>
            <p className="text-gray-800">이란?</p>
          </div>
          <div className="flex flex-col items-center w-full py-10 mt-10 text-white shadow-lg bg-gradient-to-b from-gradient1 to-gradient2 rounded-3xl">
            <p className="text-lg text-center">
              디지털 기기와 다양한 도구들로 창의적인 만들기 활동을 하며
              <br />
              자신의 아이디어를 실현시킬 수 있는 공간입니다.
              <br />
              <br />
              창의적인 만들기 활동으로 아이디어를 실현시키는 사람을 ‘메이커’라고
              하며
              <br />
              코끼리 메이커스페이스에서는 메이커 네트워크를 성장시키고 있습니다.
            </p>
          </div>
        </section>
        {/* section2 */}
        {/* <section className="flex flex-col gap-10 bg-red-400"> */}
        <section className="flex flex-col gap-28">
          {/* 1 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 메이커 교육 · 개발 수행
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “남녀노소 누구나 쉽게 이해하는 메이커 교육”
              </p>
              <p className="text-base leading-5 text-gray-600">
                디지털 제작 기기를 활용하여 메이커 교육을 진행하고 지역 사회에
                메이커 문화를 확산시킵니다. 기존에 보유한 여러 분야의 전문가들을
                네트워크 삼아 다양 분야를 메이커 교육과 접목시켰습니다.
                아두이노를 활용한 교육, 레이저 커트를 활용한 실크스크린 등
                디지털 제작 기기와 결합한 교육을 진행합니다.
              </p>
            </div>
          </div>
          {/* 2 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 찾아가는 메이커스페이스 교육
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “농 · 어촌, 도서산간 지역 모두가 참여할 수 있는 메이커 교육”
              </p>
              <p className="text-base leading-5 text-gray-600">
                메이커 교육이 부족한 곳에 직접 찾아가 디지털 제작 기기, 목공 등
                장비를 체험할 수 있는 메이커 교육을 진행합니다. 메이커스페이스를
                접하지 못한 아이들도 함께 만들고 소통하며 메이커 문화를
                전달합니다.
              </p>
            </div>
          </div>
          {/* 3 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 메이커 행사 기획 · 운영
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “메이커 행사를 기획하고 운영합니다.”
              </p>
              <p className="text-base leading-5 text-gray-600">
                코끼리 협동조합은 다양한 분야의 전문가 네트워크를 보유하고 있습니다.
                전문가들고 함께 마을에 찾아가 주민들과 협탁을 제작하거나 우리의
                이야기가 담긴 메이커 행사를 진행합니다. 또한 메이커 네트워크를
                통해 협업하여 많은 행사를 함께 기획하고, 장비 지원을 하고
                있습니다.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Works3;
